import { useRequiredContext } from "@lib/utils";
import { ChipFilterNew } from "@molecules";

import { HaNContext } from "../shell/HaNContext";
import { HaNFilterBarContext } from "../shell/regions/HaNFilterBarContext";

export const FacilitiesFilters = () => {
  const { tab } = useRequiredContext(HaNContext);

  if (tab !== "facilities") return null;

  return <FacilitiesFiltersContent />;
};

// The facility types the building has
const FacilitiesFiltersContent = () => {
  const { areFiltersTransparent } = useRequiredContext(HaNFilterBarContext);

  return (
    <ChipFilterNew
      filterSlice="HereAndNow_Facilities"
      testIdPrefix="HaNFacilityFilters"
      areFilterTransparent={areFiltersTransparent}
    />
  );
};
